import config from '@config/common'
import {HttpRequest} from '@helpers/http'



/**
 * Http Request
 */
export const http = HttpRequest(config.env.ENDPOINT)



/**
 * Get cookies
 * @param key
 */
export function getCookies(key:any = null) {
  const data = document.cookie
  const cookies:{[key:string]: string} = {}

  console.log(data)
  if(data) {
    data.split(';').forEach((item:string) => {
      var [name, value]:any = item.trim().split(/=/).map(decodeURIComponent)
      if(name) {
        value = value === 'true' ? true : value
        value = value === 'false' ? false : value
        
        cookies[name] = value
      }
    })
  }
  console.log(cookies)
  if(key) {
    return cookies[key]
  }
  return cookies
}


/**
 * Convert datetime
 * @param ts 
 */
export function datetime(ts: string | number) {
  var date: any = new Date(ts)
  var week = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
  ]
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

  /**
   * Time with 12 hours format
   */
  var toTime = (format = true) => {
    var h = date.getHours()
    var m: any = date.getMinutes()

    h = h % 12;
    h = h ? h : 12
    m = m < 10 ? '0'+m : m

    let f = ''
    if(format) {
      f = ` ${date.getHours() >= 12 ? 'PM' : 'AM'}`
    }
    return `${h}:${m}${f}`
  }

  const day = week[date.getDay()]
  const _date = [
    months[date.getMonth()],
    date.getDate(),
    date.getFullYear()
  ]
  return {
    toTime,
    getDate() {
      return `${day}, ${_date.join(' ')}`
    },
    getFullDate() {
      var _date = [
        months[date.getMonth()],
        date.getDate(),
        date.getFullYear()
      ]
      return `${week[date.getDay()]}, ${_date.join(' ')} at ${toTime()}`
    }
  }
}



/**
 * Validate
 */
export const validate = {
  email: (text: string) => {
    if(text.match(/([a-z0-9.]+)@([a-z0-9-]+)\.([a-z]{2,3})/)) {
      return true
    }
  },
  /**
   * Check password strength
   */
  isPasswordStrong(password: string, email: any = null, length = 10) {
    let nu = [], lc = [], uc = [], sp = [], at = []

    /**
     * Password should not in the email
     */
    if(email) {
      email = email.split('@')

      if(password.match(email[0])) {
        return 'Password must not be found in your email address.'
      }
    }
    /**
     * Check password length
     */
    if(password.length < length) {
      return `Password must be at least ${length} characters long.`
    }

    for(let text of password.split('')) {
      /**
       * Check if has special character
       */
      let sm = text.match(/^[\W]$/)
      if(sm) {
        sp.push(sm[0])
      }
      /**
       * Check if has number
       */
      let nm = text.match(/^[\d]$/)
      if(nm) {
        nu.push(nm[0])
      }
      /**
       * Check lowercase
       */
      let lm = text.match(/^[a-z]$/)
      if(lm) {
        lc.push(lm[0])
      }
      /**
       * Check uppercase
       */
      let um = text.match(/^[A-Z]$/)
      if(um) {
        uc.push(um[0])
      }
    }

    /**
     * Errors
     */
    if(uc.length < 1) {
      at.push('upper case')
    }
    if(lc.length < 1) {
      at.push('lower case')
    }
    if(nu.length < 1) {
      at.push('numeric')
    }
    if(sp.length < 1) {
      at.push('and special character')
    }

    if(at.length > 0) {
      if(at.length === 1) {
        return `Password must be at least ${at[0].toLocaleLowerCase()}`
      }
      else {
        return `Password must be at least one of each of the following characters. ${at.join(', ')}.`
      }
    }
    return true
  }
}
